var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticStyle:{"z-index":"99999"},attrs:{"title":_vm.videoTitle,"visible":_vm.visible,"modal-append-to-body":false,"before-close":_vm.onClose},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('video',{key:_vm.videoSrc,staticClass:"video-box",attrs:{"src":_vm.videoSrc,"controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }